import React from 'react';
import AppLayout from '../../../layouts/app/AppLayout';
import '../custom.scss';

import { translateThis } from '../../../helpers/language.helper';
import AppIcons from '../../../assets/images/icons';

import SVGIcons from '../../../assets/images/icons/svgIcons';




const WaterProjectDetail = () => {
    // custom home functions here
    const pageName = "Projects";

    const forVolunteerCon = [
        {
            icon: <SVGIcons.CircularTick />,
            title: 'Empower volunteers to make a positive impact by providing clean drinking water and green energy to communities in Africa.',
        },
        {
            icon: <SVGIcons.CircularTick />,
            title: 'Provide training to volunteers on the use of off-the-grid water generators and sustainable energy practices.',
        },
        {
            icon: <SVGIcons.CircularTick />,
            title: 'Equip volunteers with knowledge about the health impacts of unsafe water and the importance of clean water for preventing diseases.',
        },
    ];

    return (
        <AppLayout
            pageName={pageName}
        >

            <div className="main-content-wrapper project-detail-wrapper f-wrp">
                <div className='main-container-wrp'>
                    <div className='project-detail-blk f-wrp'>
                        <div className='each-proj-detail-box f-wrp'>
                            <h1>{translateThis("what")} <b>{translateThis("we do")}</b></h1>
                            <p>{translateThis("WDP East Africa focuses on providing safe drinking water and green energy solutions to empower communities, particularly targeting schools and hospitals. We recognize that access to clean water and reliable energy is fundamental to sustainable development. By implementing innovative technologies and forging strategic partnerships, we aim to alleviate the burden of water scarcity and improve overall quality of life. Our off-the-grid water generators, which harness ambient air vapor to produce pure water, are a testament to our commitment to green, sustainable solutions. These generators are designed to operate with minimal external electricity, produce no carbon footprint, and function independently of weather conditions, making them ideal for diverse African environments.")}</p>
                        </div>
                        <div className='each-proj-detail-box f-wrp'>
                            <h1>{translateThis("About")} <b>{translateThis("us")}</b></h1>
                            <p>{translateThis("The World Development Programme (WDP) , under the leadership of His Excellency Vishnou Toolcanon, is dedicated to addressing critical issues related to water and energy in Africa. We are committed to sustainable development and improving living conditions across the continent. Our mission is to ensure that by 2030, every community in Africa has easy access to clean drinking water. Collaborating with partners from the United States and negotiating with heads of state across Africa, we strive to create impactful, lasting change.")}</p>
                            
                        </div>
                        <div className='each-proj-detail-box f-wrp'>
                            <h1>{translateThis("Projects and")} <b>{translateThis("initiatives")}</b></h1>
                            <p>{translateThis("projInitiativeText1")}</p>
                            <p>{translateThis("projInitiativeText2")}</p>
                            <p>{translateThis("projInitiativeText3")}</p>
                            <p>{translateThis("projInitiativeText4")}</p>
                        </div>
                        <div className='for-volunteer-box f-wrp'>
                            <div className='for-volunteer-con'>
                                <h1>{translateThis('For volunteers')}</h1>
                                <ul>
                                    {forVolunteerCon.map((element, key) => (
                                        <li key={key}>
                                            <span className='impact-icon'>{element.icon}</span>
                                            <p>{translateThis((element.title))}</p>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div className='for-volunteer-img'>
                                <span><img src={AppIcons.waterProjVolunteer} alt='For volunteers' /></span>
                            </div>
                        </div>


                    </div>
                </div>

            </div>
        </AppLayout>
    )
}

export default WaterProjectDetail;